export default "__VITE_ASSET__cb87e5b9__"